import cn from 'classnames';
import styles from './BottomPanel.module.scss';
import { ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { AnimatePresence, motion } from 'framer-motion';

type BottomPanelProps = {
  className?: string;
  children: ReactNode;
};

export function BottomPanel({ className, children }: BottomPanelProps) {
  const wrapperClassName = cn(styles.wrapper, className);
  const [body, setBody] = useState<HTMLBodyElement | null>(null);

  useEffect(() => {
    const body = document.querySelector('body');

    if (body) {
      setBody(body);
    }
  }, []);

  if (!body) return null;

  return createPortal(
    <AnimatePresence>
      <motion.div
        className={wrapperClassName}
        initial={{ translateY: '100%' }}
        animate={{ translateY: '0' }}
        exit={{ translateY: '100%' }}
        transition={{ duration: 0.3 }}
      >
        {children}
      </motion.div>
    </AnimatePresence>,
    body,
  );
}
